// Free Entry Point (72h) countdown helpers — pure functions, unit-tested.

export const FEP_TOTAL_MS = 72 * 3600 * 1000;
export const RESPONSE_TOTAL_MS = 24 * 3600 * 1000;

export const remainingMs = (iso, now = Date.now()) => {
  if (!iso) return 0;
  return Math.max(0, new Date(iso).getTime() - now);
};

// 71:23:45 (hours can exceed 24)
export const formatCountdown = ms => {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = n => String(n).padStart(2, '0');
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
};

export const progressRatio = (ms, totalMs) =>
  totalMs > 0 ? Math.min(1, Math.max(0, ms / totalMs)) : 0;
